const addToCartEvent = function () {

    jQuery(document.body).on('added_to_cart', function () {
        const event = new CustomEvent('addedToCart');

        document.body.dispatchEvent(event);
    });
}

export default addToCartEvent;